import { makeStyles } from '@material-ui/core';
import React from 'react';
import { usePrefixTranslation } from '../../../i18n';
import { actions, useTypedDispatch, useTypedSelector } from '../../../redux';
import { theme } from '../../../theme/theme';
import { Button } from '../../global';
import stopwatchPicture from './ReadyToInspectStopwatch.svg';

const useReadyToInspectClasses = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: 1,
        marginTop: 50,
        color: theme.colors.darkBlue[5],
        '& > span:first-of-type': {
            ...theme.typography.headings.h2,
        },
        '& > span:last-of-type': {
            ...theme.typography.content.text,
        },
    },
    buttons: {
        display: 'flex',
        gap: 10,
        marginTop: 50,
    },
});

/**
 * Editor for projects in the ready to inspect mode.
 *
 * @param props.onSchedule callback triggered when the reschedule button is clicked
 */
export const ReadyToInspect = (props: { onSchedule: () => void }) => {
    const classes = useReadyToInspectClasses();
    const { t } = usePrefixTranslation('project', { project: 'editor.ReadyToInspect' });
    const dispatch = useTypedDispatch();
    const { project } = useTypedSelector(state => ({ project: state.project.changed }));

    if (!project) return <span>{'#project not in store'}</span>;

    return (
        <div className={classes.root}>
            <img src={stopwatchPicture} width={120} height={110} alt='stopwatch' />
            <span>{t('title')}</span>
            <span>{t('subtitle', { start: project.estimated_start_date, end: project.estimated_completed_date })}</span>
            <div className={classes.buttons}>
                <Button variant='outlined' onClick={props.onSchedule}>
                    {t('button-schedule')}
                </Button>
                <Button
                    variant='contained'
                    onClick={() => {
                        dispatch(actions.project.edit({ status: 'in progress' }));
                        dispatch(actions.project.commit());
                        dispatch(actions.project.update(true)).catch(error => {
                            dispatch(actions.project.edit({ status: 'ready to inspect' }));
                            dispatch(actions.project.commit());
                        });
                    }}
                >
                    {t('button-start')}
                </Button>
            </div>
        </div>
    );
};
